import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { DEFAULT_AVATAR } from '../../features/constants/avatars';
import { RootState } from '../../features/redux/store';
import AvatarImage from '../common/AvatarImage';

export interface IAvatarMenu {}

const AvatarMenu: React.FC<IAvatarMenu> = (props) => {
  const userName = useSelector((state: RootState) => state.user.userName);
  const role = useSelector((state: RootState) => state.user.role);
  const userAvatar = useSelector((state: RootState) => state.user.avatar) || DEFAULT_AVATAR;
  const userCode = useSelector((state: RootState) => state.user.userCode);

  return (
    <>
      <Link to={`/profile`} style={{ textDecoration: 'none', color: 'inherit' }}>
        <Grid container alignItems="center" spacing={1} sx={{ marginLeft: '1rem', gap: '0.5rem' }}>
          <Typography
            sx={{
              color: 'inherit',
            }}
          >
            {userName || userCode}
          </Typography>
          <Typography
            sx={{
              color: 'inherit',
            }}
          >
            ({role})
          </Typography>
          <AvatarImage avatarUrl={userAvatar} size={40} />
        </Grid>
      </Link>
    </>
  );
};

export default AvatarMenu;
